export default __webpack_public_path__ + "static/media/meetingsSquare.6a67c6d8.svg";